import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Typography from 'material-ui/Typography';
import MuiButton from 'material-ui/Button';

const styles = () => ({
  container: {
    margin: '100px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    textAlign: 'center',
  },

  title: {
    fontSize: '18px',
    lineHeight: '22px',
  },

  subheading: {
    marginTop: '14px',
    lineHeight: '24px'
  },

  linkBtn: {
    color: '#1A65FF',
    border: 'none',
    padding: '5px',
    marginTop: '10px',
    minHeight: 'unset',
    minWidth: 'unset',
    fontSize: '13px',
    textDecoration: 'underline',
  },
});

const ResultEmptySection = props => {
  const { classes } = props;
  return (
    <div className={classes.container}>
      <Typography variant="display1" className={classes.title}>注文はありません。</Typography>
      <Typography variant="body2" className={classes.subheading}>
        決裁者にレターを送りましょう。
      </Typography>
      <MuiButton
        onClick={() => props.goTo('/executive-list')}
        color="primary"
        className={classes.linkBtn}>
        決裁者を検索
      </MuiButton>
    </div>
  );
}

ResultEmptySection.propTypes = {
  classes: PropTypes.object.isRequired,
  goTo: PropTypes.func.isRequired,
};

export default withStyles(styles)(ResultEmptySection);



// WEBPACK FOOTER //
// ./src/components/OrderList/sections/ResultEmptySection.jsx